import React from 'react';
import { Modal } from 'syngenta-digital-cropwise-react-ui-kit';

import DiscardIcon from 'assets/DiscardIcon';

interface ConfirmModalConfig {
  icon?: React.ReactNode;
  title: React.ReactNode;
  content: React.ReactNode;
  contentStyles?: React.CSSProperties;
  okText: string;
  okButtonProps?: Record<string, any>;
  cancelText: string;
  cancelButtonProps?: Record<string, any>;
  onOk: () => void;
  width?: number | string;
}

const showConfirmModal = ({
  icon = <DiscardIcon />,
  title,
  content,
  contentStyles = { paddingRight: 36 },
  okButtonProps = {
    style: {
      borderRadius: 4,
      background: '#CF3537',
      padding: '10px 16px',
      color: '#FFF',
      fontSize: 14,
      fontWeight: 400,
      marginLeft: 8
    }
  },
  okText,
  cancelText,
  cancelButtonProps = {
    style: {
      borderRadius: 4,
      background: '#FFF',
      color: '#14151C',
      fontSize: 14,
      fontWeight: 400,
      padding: '10px 16px',
      border: '1px solid #C2C7D0'
    }
  },
  onOk,
  width = 520
}: ConfirmModalConfig) => {
  Modal.confirm({
    icon: null,
    title: (
      <span className="flex items-center" style={{ gap: 12 }}>
        <span className="flex items-center">{icon}</span>
        <span className="font-semibold text-lg text-neutral-1000">{title}</span>
      </span>
    ),
    content: (
      <div className="flex items-start" style={contentStyles}>
        <span className="inline-block" style={{ width: 36, minWidth: 36 }} />
        <span className="font-normal text-base leading-normal break-words text-left mt-0 flex-1 text-neutral-1000">
          {content}
        </span>
      </div>
    ),
    okText,
    cancelText,
    centered: true,
    closable: false,
    transitionName: '',
    maskTransitionName: '',
    width,
    okButtonProps,
    cancelButtonProps,
    onOk,
    onCancel: () => {},
    maskClosable: false
  });
};

export default showConfirmModal;
